export const MINIMUM_SEARCH_UNIVERSE_ELEMENT = 5000;
